import { render, staticRenderFns } from "./imCommonModal.vue?vue&type=template&id=088b994c&scoped=true"
import script from "./imCommonModal.vue?vue&type=script&lang=js"
export * from "./imCommonModal.vue?vue&type=script&lang=js"
import style0 from "./imCommonModal.vue?vue&type=style&index=0&id=088b994c&prod&lang=scss"
import style1 from "./imCommonModal.vue?vue&type=style&index=1&id=088b994c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b994c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PZPopup: require('/drone/src/components/PZPopup/PZPopup.vue').default})
